import {
  DataCollectionRecord,
  useCensus1940Collection,
} from '@ltvco/refresh-lib/hooks';
import { AdvancedSearchURLParams } from '@ltvco/refresh-lib/v2';
import React, { useEffect } from 'react';

interface CensusRecordsFetcherProps {
  searchData: AdvancedSearchURLParams;
  // eslint-disable-next-line no-unused-vars
  setCensusResults: (data: DataCollectionRecord[] | undefined) => void;
}

export function CensusRecordsFetcher({
  searchData,
  setCensusResults,
}: CensusRecordsFetcherProps) {
  const { data: censusResults } = useCensus1940Collection(true, {
    primary_person_self_name_given_names: searchData.fName,
    primary_person_self_name_middle_names: searchData.mName,
    primary_person_self_name_surname: searchData.lName,
    event_primary_location_level_2: searchData.state,
    event_primary_location_level_3: searchData.city,
    primary_person_self_age: Number(searchData.age),
  });

  useEffect(() => {
    setCensusResults(censusResults);
  }, [censusResults, setCensusResults]);

  return <React.Fragment />;
}
